<template>
  <div class="mb-5">
    <v-card class="mx-auto">
      <v-card-title>
        <v-btn
          text
          @click="$router.replace({ name: 'RegistrationList' })"
          class="mr-2"
          small
        >
          <v-icon left>mdi-arrow-left</v-icon>
          Back
        </v-btn>
        <v-spacer />
        <div class="text-lg-h6">Renewal</div>
        <v-spacer />
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form v-model="isValid" ref="renewForm">
          <v-row>
            <v-col cols="12" md="3" sm="12" xs="12">
              <v-select
                placeholder="Enter Programme"
                label="programme"
                persistent-placeholder
                v-model="studentProgramme"
                clearable
                prepend-inner-icon="school"
                outlined
                :items="setupProgrammes"
                item-text="description"
                item-value="code"
                :disabled="programme.length !== 0"
                dense
              />
            </v-col>
            <v-col cols="12" md="3" sm="12" xs="12">
              <v-select
                placeholder="Enter Intake Semester"
                label="intake Semester"
                persistent-placeholder
                v-model="formData.intakeSemester"
                clearable
                prepend-inner-icon="school"
                outlined
                dense
                :items="semesters"
                item-text="description"
                item-value="code"
              />
            </v-col>
            <v-col cols="12" md="3" sm="12" xs="12">
              <v-select
                placeholder="Enter Intake Stage"
                label="intake Stage"
                persistent-placeholder
                v-model="formData.intakeStage"
                clearable
                prepend-inner-icon="school"
                outlined
                dense
                :items="stages"
                item-text="description"
                item-value="code"
              />
            </v-col>
            <v-col cols="12" md="3" sm="12" xs="12">
              <v-select
                placeholder="Enter Student Type"
                label="student Type"
                persistent-placeholder
                v-model="formData.studentType"
                clearable
                prepend-inner-icon="school"
                :items="studentTypes"
                item-text="description"
                item-value="code"
                outlined
                dense
              />
            </v-col>
            <!-- <v-col cols="12" md="12" sm="12" xs="12">
              <v-textarea
                placeholder="Enter Remarks"
                label="remarks"
                persistent-placeholder
                v-model="formData.remarks"
                rows="2"
                clearable
                prepend-inner-icon="history_edu"
                outlined
                dense
              />
            </v-col> -->
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn color="primary" class="align-self-end" @click="saveReg">
          <v-icon class="mx-2">save</v-icon>
          save
        </v-btn> -->
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import AuthService from "../../dashboard/modules/auth/AuthService";
import moment from "moment";
export default {
  name: "RenewForm",
  props: {
    programme: {
      type: String,
      default: "",
    },
    programmeStages: Array,
    semesters: Array,
    setupProgrammes: Array,
    currentRegistration: Object,
  },
  data: function () {
    return {
      isValid: false,
      formData: {
        programme: "",
        intakeSemester: "",
        intakeStage: "",
        remarks: "",
        studentType: "",
      },
      stages: [],
    };
  },
  computed: {
    studentProgramme: {
      get() {
        this.updateStages(
          this.programme.length !== 0
            ? this.programme
            : this.formData.programme,
        );
        return this.formData.programme;
      },
      set(value) {
        this.updateStages(value);
      },
    },
    studentTypes() {
      return this.$store.getters["Renewal/studentTypes"];
    },
  },
  methods: {
    saveReg() {
      if (!this.isValid) {
        this.$refs.renewForm.validate();
      } else {
        this.formData.studentNo = AuthService.user.student_id;
        this.formData.registrationDate = moment(new Date()).format("YYYY-MM-D");
        this.$store.dispatch("Renewal/submitRegistration", {
          ...this.formData,
        });
      }
    },
    updateStages(val) {
      this.formData.programme = val;
      this.stages = this.programmeStages.filter(
        (item) => item.programmeCode === val,
      );
    },
  },
};
</script>
